// 首屏聚合接口数据
export default {
  namespaced: true,
  state: {
    fundDetail1: {},
  },
  mutations: {
    setFundDetail1(state, info) {
      state.fundDetail1 = info;
    },
  },
};
